import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
    selector: 'app-common-popup',
    templateUrl: './common-popup.component.html',
    styleUrls: ['./common-popup.component.scss'],
    standalone: false
})
export class CommonPopupComponent {
  @Input() isOpen: boolean = false;
  @Input() imageSrc: string = '';
  @Input() imageCss: string = '';
  @Input() heading: string = '';
  @Input() headingCss: string = '';
  @Input() subtext: string = '';
  @Input() isFullWidthButtons: boolean = false; // New flag
  @Input() poupWidth: string = 'max-w-xl';
  @Input() closeButtonText: string = 'Cancel';
  @Input() closeButtonTextCss: string = '';
  @Input() confirmButtonText: string = 'Confirm';
  @Input() confirmButtonTextCss: string = '';
  @Input() isConfirmDisabled: boolean = false;

  @Output() onClose = new EventEmitter<void>();
  @Output() onConfirm = new EventEmitter<void>();

  close() {
    this.onClose.emit();
  }

  confirm() {
    if (this.isConfirmDisabled) {
      return;
    }
    this.onConfirm.emit();
  }
}